export default __webpack_public_path__ + "static/media/facemask.09f1db94.jpg";